var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 15C19.335 14.9956 18.0963 15.5043 17.1818 16.4141C16.2673 17.3239 15.7522 18.56 15.75 19.85V24.75C15.75 24.9489 15.829 25.1397 15.9697 25.2803C16.1103 25.421 16.3011 25.5 16.5 25.5H18.25C18.6642 25.5 19 25.1642 19 24.75V19.85C18.9997 19.3906 19.1948 18.9527 19.5367 18.6458C19.8786 18.3389 20.3349 18.1919 20.7917 18.2417C21.63 18.3473 22.2566 19.0634 22.25 19.9083V24.75C22.25 25.1642 22.5858 25.5 23 25.5H24.75C25.1642 25.5 25.5 25.1642 25.5 24.75V19.85C25.4978 18.56 24.9827 17.3239 24.0682 16.4141C23.1537 15.5043 21.915 14.9956 20.625 15Z",
    fill: "#212B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5C10.5 16.0858 10.8358 15.75 11.25 15.75H13.5C13.9142 15.75 14.25 16.0858 14.25 16.5V24.75C14.25 25.1642 13.9142 25.5 13.5 25.5H11.25C10.8358 25.5 10.5 25.1642 10.5 24.75V16.5Z",
    fill: "#212B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.375C14.25 13.4105 13.4105 14.25 12.375 14.25C11.3395 14.25 10.5 13.4105 10.5 12.375C10.5 11.3395 11.3395 10.5 12.375 10.5C13.4105 10.5 14.25 11.3395 14.25 12.375Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.514b0910ed73e5f31351a3fcbf537569.svg";
export { ForwardRef as ReactComponent };